var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "url(#paint0_linear_10686_10841)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 7.84961C22.0537 7.84961 26.1505 11.9464 26.1505 17.0001C26.1505 22.0538 22.0537 26.1506 17.0001 26.1506C11.9464 26.1506 7.84961 22.0538 7.84961 17.0001C7.84961 11.9464 11.9464 7.84961 17.0001 7.84961Z",
    stroke: "#353535",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1831 18.0449L15.6943 18.5561C15.9766 18.8384 16.4344 18.8384 16.7167 18.5561L19.2728 16",
    stroke: "#353535",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10686_10841",
    x1: 0,
    y1: 0,
    x2: 61.3303,
    y2: 7.24902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValide);
export default __webpack_public_path__ + "static/media/valide.d37e9e26b4e811f9c5d9caed8652c613.svg";
export { ForwardRef as ReactComponent };